	<app-page *ngIf="vo$ | async; let vo">
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<app-button
				*ngIf="vo.projectVersionCount > 1"
				id="{{ cmpId + 'version-switcher' }}"
				class="app-subscription-list__version-switcher-btn"
				[leftIcon]="DcIcons.SwitchVersion"
				(click)="openSwitchableConsumedProjectsModal()"
				i18n="@@subscription.versionSwitcher.action.btn">
				switcher-version
			</app-button>

			<button
				*ngIf="vo.hasCreatePermission"
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				class="app-subscription-list__new-btn"
				mat-icon-button
				color="primary"
				(click)="createNew()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
				<app-subscription-list
					(createSubscriptionAction)="createNew()"></app-subscription-list>
		</app-page-content>
	</app-page>


